export type Market = 'AU' | 'HK' | 'ID' | 'MY' | 'NZ' | 'PH' | 'SG' | 'TH';

export enum MarketLocationIds {
  AU = '3000',
  HK = '24469',
  ID = '24473',
  MY = '24500',
  NZ = '3001',
  PH = '24534',
  SG = '24553',
  TH = '24572',
}
